import React from 'react';
import { connect } from 'react-redux';

import { closeMessageModal } from 'actions/modal';

import Modal from './component';

const ModalWrap = ({ className, active, onDeactive, children, inline, ...other }) => (
	<Modal className={className} active={active} onDeactive={onDeactive} inline={inline}>
		{children({ active, onDeactive, ...other })}
	</Modal>
);

const mapStateToProps = ({ modal }, { name }) => ({
	active: modal[name].open,
	message: modal[name].message,
});

const mapDispatchToProps = (dispatch, { name, onDeactive = () => {} }) => ({
	onDeactive: () => {
		dispatch(closeMessageModal(name));
		onDeactive();
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalWrap);



// WEBPACK FOOTER //
// ./src/components/molecules/Modal/index.js